import { readRefreshedAccessToken } from '../utils/readRefreshedAccessToken';
import { isUsableRefreshToken, setTokens } from '../utils/tokens';
import instance from './scorpiusInstance';
import {
  REFRESH_USER_TOKEN_START,
  REFRESH_USER_TOKEN_SUCCESS,
  REFRESH_USER_TOKEN_ERROR,
} from './types';

export const refreshUserTokenStart = () => ({
  type: REFRESH_USER_TOKEN_START,
});

export const refreshUserTokenSuccess = token => ({
  type: REFRESH_USER_TOKEN_SUCCESS,
  token,
});

export const refreshUserTokenError = error => ({
  type: REFRESH_USER_TOKEN_ERROR,
  error,
});

export const refreshUserToken = refresh_token => async dispatch => {
  // The endpoint rejects a missing or empty refresh_token with a 400, so ask
  // the question here rather than paying a round trip to be told. IRP sessions
  // and legacy `?access_token=` auto-login links store no refresh token, and
  // older writes left the string 'null' behind.
  if (!isUsableRefreshToken(refresh_token)) {
    throw dispatch(
      refreshUserTokenError(
        new Error('No usable refresh token to refresh with'),
      ),
    );
  }

  dispatch(refreshUserTokenStart());
  try {
    const response = await instance.post('/user/api-token-auth/refresh', {
      refresh_token,
    });

    const token = readRefreshedAccessToken(response.data);
    if (!token) {
      // Persisting an absent token would store `undefined` and have
      // authReducer stamp an hour's expiration on it, leaving a session that
      // looks healthy while sending `Bearer undefined` on every request.
      throw new Error('Refresh response carried no access token');
    }

    // The endpoint returns only { token }, so the stored refresh token is
    // carried forward unchanged.
    setTokens({ token, refresh_token });

    // Update the scorpius instance with new Bearer token
    instance.defaults.headers.Authorization = `Bearer ${token}`;

    return dispatch(refreshUserTokenSuccess(token));
  } catch (error) {
    throw dispatch(refreshUserTokenError(error));
  }
};

export default refreshUserToken;
